import {useRequest} from '@aboutyou/data-fetcher';
import {useInViewEffect} from '@aboutyou/ui-components';
import {useCallback} from 'react';

// The "Free delivery unlocked" label is shown if the MOV is reached
// AND the user previosuly viewed the MOV progress bar.
export const useShouldShowMovReachedLabel = () => {
  const {ref: movProgressRef} = useInViewEffect<HTMLDivElement>(
    inView => {
      !data?.shouldShowMovReachedLabel && setUserSawMovProgressBar(inView);
    },
    {triggerOnce: true},
  );

  const {data, updateCache} = useRequest<{
    shouldShowMovReachedLabel: boolean;
  }>('user-seen-mov-progress', () => ({
    shouldShowMovReachedLabel: false,
  }));

  const setUserSawMovProgressBar = useCallback(
    (shouldShowMovReachedLabel: boolean) => {
      updateCache({shouldShowMovReachedLabel});
    },
    [updateCache],
  );

  return {
    movProgressRef,
    shouldShowMovReachedLabel: data?.shouldShowMovReachedLabel,
  };
};
